import React, { useState, useRef } from "react";
import supabase from "config/supabaseClient";
import emailjs from "@emailjs/browser";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Label,
  Alert,
} from "reactstrap";

// core components
import MultiDropdownNavbar from "components/Navbars/MultiDropdownNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import FooterWhite from "components/Footers/FooterWhite.js";
import MainNavbar from "components/Navbars/MainNavbar";
import { Navigate } from "react-router-dom";
import MainFooter from "components/Footers/MainFooter";
import Playlist from "components/PlayList";

function Index() {
  const [status, setStatus] = useState(null);
  const [visible, setVisible] = useState(true);

  const homePageDemos = [
    {
      id: 1,
      title: "🎧 Commercial Demo - 1 Minute Preview",
      url: "https://shannenaudio.netlify.app/Shannen%20Velasco%20Commercial%20Demo%2060.mp3",
    },
    {
      id: 1,
      title: "🎧 Character Work Samples",
      url: "https://shannenaudio.netlify.app/ShannenVelasco_Reel%202024.wav",
    },
  ];

  const form = useRef();

  console.log("[supabase]", supabase);

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });

  const onDismiss = () => setVisible(false);

  const sendEmail = (e) => {
    console.log("[E]", form.current);
    e.preventDefault();

    emailjs

      .sendForm(
        "service_obz411f", // e.g., service_gmail

        "template_tyqj7hb", // e.g., template_contact

        form.current,

        "RzbEJmyMe8HXH_Fru" // e.g., your user/public key from EmailJS
      )

      .then(
        (result) => {
          console.log(result.text);

          setStatus("SUCCESS");

          form.current.reset();
        },

        (error) => {
          console.log("ERROR", error.text);

          setStatus("FAILED");
        }
      );
  };

  const onPlayHandler = (id) => {
    console.log('[WHAT IS MY ID]',id);

  
    }
  

  return (
    <>
      {status === "SUCCESS" && (
        <Alert
          color="success"
          className="mb-0"
          isOpen={visible}
          toggle={onDismiss}
          style={{
            zIndex: 9999,
            position: "relative",
          }}
        >
          ✅ Your message has been sent!
        </Alert>
      )}

      {status === "FAILED" && (
        <Alert
          color="warning"
          className="mb-0"
          isOpen={visible}
          toggle={onDismiss}
          style={{
            zIndex: 9999,
            position: "relative",
          }}
        >
          ❌ Failed to send. Please try again.
        </Alert>
      )}

      <MainNavbar />
      <LandingPageHeader />
      {/* <Alert color="success" className="mb-0" isOpen={visible} toggle={onDismiss}>
          ✅ Your message has been sent!
        </Alert> */}
      <div className="main">
        <div className="wrapper">
          <div className="section text-center landing-section">
            <Container>
              <Row>
                <Col className="ml-auto mr-auto" md="8">
                  <h1>Let's Get to Work!</h1>
                  <br />
                  <h5>
                    Need a voice for your next project? I got you covered!
                    <br />
                    <br />
                    Whether your script calls for something bright and cheerful,
                    calm and meditative, or sultry and confident, I'm here to
                    bring your vision to life.
                  </h5>
                  <br />
                  <Button
                    className="btn-fill btn-round"
                    color="danger"
                    href="about-me"
                  >
                    Want to learn more?
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="section section-dark text-center landing-section">
            <Container>
              <h1 className="title">Demos</h1>
            </Container>
            <Container>
              <Row>
                <Col md="6">
                  <img
                    alt=""
                    src={require("assets/img/indexDemo.png")}
                    width={330}
                    height={460}
                  />
                </Col>
                <Col md="6" style={{ paddingTop: 50 }}>
                  <Playlist voiceDemos={homePageDemos} 
                  onPlayHandler={onPlayHandler}
                  id= "general"
                  />
                  <br />
                  <Button className=" btn-round" color="white" href="demos">
                    More
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="section landing-section">
            <Container>
              <Row>
              <Col className="ml-auto mr-auto" md="8">
                  <h2 className="text-center">
                    {" "}
                    Like what you hear? Let's Talk!
                  </h2>
                  <br/>
                  <form ref={form} onSubmit={sendEmail}>
                    <FormGroup>
                      <Label for="name">Name</Label>
                      <Input type="text" name="name" id="name" required />
                    </FormGroup>

                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Input type="email" name="email" id="email" required />
                    </FormGroup>

                    <FormGroup>
                      <Label for="message">Message</Label>
                      <Input
                        type="textarea"
                        name="message"
                        id="message"
                        rows="4"
                        required
                      />
                    </FormGroup>

                    <Button color="danger" type="submit" block>
                      Send Message
                    </Button>
                  </form>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
      <MainFooter />
    </>
  );
}

export default Index;
